/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelectOneGhost from 'DesignSystem/TysiaSelectOneGhost/index'
import TysiaSelectOneGhostArrow from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostArrow/index'
import TysiaSelectOneGhostContent from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostContent/index'
import TysiaSelectOneGhostIcon from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostIcon/index'
import TysiaSelectOneGhostInput from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import Tysiav2DocumentHeart from 'DesignSystem/Svgs/Tysiav2DocumentHeart/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Template/Content",
  onChange
  
}) {
let templatesValueData = fromData.useDataValue({ viewPath,
context: 'templates',
})
let letterDocumentTemplateIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'document_template_id',
})
let letterDocumentTemplateIdChangeData = fromData.useDataChange({ viewPath,
context: 'letter',
path: 'document_template_id',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaSelectOneGhost
  viewPath={`${viewPath}/TysiaSelectOneGhost`}
 alignSelf="auto"
 placeholder="Letter"
 size="small"
 data="templates"
 from={templatesValueData}
 data="letter.document_template_id"
 value={letterDocumentTemplateIdValueData}
 onChange={letterDocumentTemplateIdChangeData}
>
{childProps => (
<TysiaSelectOneGhostContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneGhostIcon
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostIcon`}
>
{childProps => (
<Tysiav2DocumentHeart
{...childProps}
  viewPath={`${viewPath}/Tysiav2DocumentHeart`}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaSelectOneGhostIcon>
<TysiaSelectOneGhostInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostInput`}
 width="90%"
/>
<TysiaSelectOneGhostArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneGhostContent>
)}
</TysiaSelectOneGhost>
{children}
</React.Fragment>)
}